<template>
  <v-container>
    <v-sheet class="pa-4" color="card">
      <h1>Mass Email</h1>

      <h2>Instructions</h2>

      <ol>
        <li>Copy and paste the html email and a plaintext email into the relevant text areas.</li>
        <li>
          Note: The index will reject the email if either template does not contain
          <!-- prettier-ignore -->
          <span v-pre>{{unsubscribeLink}}</span>
        </li>
        <li>Send a test email to yourself by specifying your email address as the recipient</li>
        <li>If the email passes inspection, you may then send it to everyone</li>
      </ol>
      <br />
      Note: The index will attach the common footer to the bottom of any email, which will include contact information
      and an unsubscribe link.

      <v-form v-model="formIsValid" ref="emailForm">
        <div class="d-flex mt-4">
          <v-text-field
            v-model="specifiedRecipient"
            :disabled="sendToAll"
            label="Recipient"
            hide-details
            outlined
            :rules="sendToAll ? [] : [rules.required, rules.validEmail]"
          ></v-text-field>
          <v-checkbox v-model="sendToAll" label="Send To All" hide-details></v-checkbox>
        </div>

        <v-text-field
          v-model="payload.subject"
          label="Subject"
          class="mt-2"
          hide-details
          outlined
          :rules="[rules.required]"
        ></v-text-field>

        <v-textarea
          v-model="payload.htmlTemplate"
          label="HTML Template"
          class="mt-2"
          outlined
          :rules="[rules.required, rules.containsUnsubscribeLink]"
        ></v-textarea>

        <v-textarea
          v-model="payload.plaintextTemplate"
          label="Plaintext Template"
          class="mt-2"
          outlined
          :rules="[rules.required, rules.containsUnsubscribeLink]"
        ></v-textarea>

        <div class="d-flex justify-end mt-4">
          <v-btn @click="sendEmail" :disabled="!formIsValid" color="primary">Send</v-btn>
        </div>
      </v-form>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "bulk-email.vue",

  data: function () {
    return {
      formIsValid: false,

      specifiedRecipient: undefined,
      sendToAll: false,

      payload: {
        recipients: undefined,
        subject: "",
        htmlTemplate: "",
        plaintextTemplate: "",
      },

      // TODO: Refactor rules into a common file. Not duplicate code
      rules: {
        required: (val) => {
          if (val === undefined) return "Required";
          if (val.length > 0) return true;
          return "Required";
        },
        validEmail: (val) => {
          //regex grabbed from emailregex.com to match email addresses. Removed 2 "unnecessary escapes"--watch for bugs.
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regex.exec(val) !== null || "Invalid Email";
        },
        containsUnsubscribeLink: (val) => {
          if (val === undefined) return "Requires '{{unsubscribeLink}}'";
          if (val.includes("{{unsubscribeLink}}")) return true;
          return "requires '{{unsubscribeLink}}'";
        },
      },
    };
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    sendEmail: async function () {
      if (!this.$refs.emailForm.validate()) {
        console.log("Showing snackbar");
        this.showSnackbar({
          text: "Invalid form",
          error: true,
        });
        return;
      }

      this.payload.recipients = this.sendToAll ? "all" : [this.specifiedRecipient];
      try {
        await this.$axios.post("/v1/emails", this.payload);
        this.showSnackbar({
          text: "Email accepted",
        });
      } catch (err) {
        this.showSnackbar({
          text: "An Error occurred",
          error: true,
        });
      }
    },
  },
};
</script>

<style scoped></style>
